import { ui } from "@patient-watch/ui";
import { useFormContext } from "react-hook-form";
import { getTestId } from "./utils/getTestId";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    name: string;
    label?: string;
    description?: string;
    required?: boolean;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: number;
    type?: "number" | "text" | "time";
    id?: string;
    autocomplete?: string;
    className?: string;
    autoFocus?: boolean;
}

const Input: React.FC<Props> = ({
    name,
    label,
    id,
    disabled,
    tabIndex,
    autocomplete,
    type,
    description,
    placeholder,
    className,
    autoFocus = false,
    required = false,
}) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            disabled={disabled}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    {!!label && (
                        <ui.FormLabel>
                            {label}
                            {required && <span className="ml-0.5 text-red-500">*</span>}
                        </ui.FormLabel>
                    )}
                    {description && <ui.FormDescription>{description}</ui.FormDescription>}
                    <ui.FormControl>
                        <ui.Input
                            {...(id ? { id } : {})}
                            autoComplete={autocomplete}
                            type={type ?? "text"}
                            tabIndex={tabIndex}
                            {...field}
                            value={field.value ?? ""}
                            placeholder={placeholder}
                            className={className}
                            autoFocus={autoFocus}
                            data-testid={getTestId(name, "input")}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Input;
